import { mapState, mapGetters, mapActions } from 'vuex'

export const attributeMethods = mapActions('attributes', [
  'getActualAttributes',
])

export const authComputed = {
  ...mapState('auth', {
    currentUser: state => state.currentUser,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'userProfile',
    'getClientId',
    'getCurrentUser',
    'getUserId',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'forget',
  'forgetClient',
  'forgetDriver',
  'resetUserPassword',
  'resetClientPassword',
  'resetDriverPassword',
  'clientLogIn',
])

export const binMethods = mapActions('bins', [
  'getBins',
  'binById',
  'serviceBinById',
  'createBin',
  'updateBin',
  'deleteBin',
  'addBinToService',
  'deleteServiceBin',
  'updateServiceBin',
  'serviceBins',
  'completeBin',
])

export const chargetypeMethods = mapActions('chargetypes', [
  'getChargeTypes',
  'getChargeTypeById',
  'createChargeType',
  'updateChargeType',
  'deleteChargeType',
])

export const serviceChargeMethods = mapActions('serviceCharges', [
  'getServiceCharges',
  'getServiceChargeById',
  'createServiceCharge',
  'updateServiceCharge',
  'deleteServiceCharge',
])

export const clientMethods = mapActions('clients', [
  'getClients',
  'createClient',
  'getClientById',
  'updateClient',
  'deleteClient',
  'createClientRequest',
  'getClientRequests',
  'acceptClientRequest',
  'updateClientPassword',
  'deleteAgreementDocument',
  'getClientsWithSitesAndServices'
])

export const clientReportMethods = mapActions('clientreports', [
  'getClientCollectionData',
  'getClientCollectionDataById',
  'getAllCollectionData',
])

export const collectionMethods = mapActions('collections', [
  'getCollections',
  'getCollectionById',
  'getCollectionsByClientID',
  'getCollectionsByServiceId',
  'getBinPickupsByCollectionId',
  'createCollection',
  'updateCollection',
  'updateCurrentCollection',
  'voidCollection',
  'deleteCollection',
  'getUnassignedCollections',
  'setCollectionRunSheet',
  'updateUnassignedCollection',
  'moveCollectionsToRunSheet',
  'getCollectionsToReAssign',
  'updateCollectionCharge',
  'notifyDriverWithCollectionData',
])
export const dashboardMethods = mapActions('dashboard', ['getDashboardData'])

export const depotMethods = mapActions('depots', [
  'getDepots',
  'createDepot',
  'updateDepot',
  'deleteDepot',
  'getDepotById',
])
export const driverMethods = mapActions('drivers', [
  'getDrivers',
  'createDriver',
  'deleteDriverPhoto',
  'driverById',
  'updateDriver',
  'deleteDriver',
  'createDriverPhoto',
])

export const instanceExceptionMethods = mapActions('instanceExceptions', [
  'getInstanceExceptionById',
  'getInstanceExceptionsByClientId',
  'getInstanceExceptionsByServiceId',
  'getInstanceExceptionsByStatus',
  'createCollectionInstanceException',
  'updateCollectionInstanceException',
  'deleteCollectionInstanceException',
])
export const invoiceMethods = mapActions('invoices', ['getInvoices'])
export const messageMethods = mapActions('messages', ['getMessages'])
export const photoMethods = mapActions('photos', [
  'photoById',
  'photosByExceptionId',
  'createPhoto',
  'updatePhoto',
  'deletePhoto',
])
export const pickupRequestMethods = mapActions('pickuprequest', [
  'getPickupRequests',
  'getClientPickupRequests',
  'createPickupRequest',
  'updatePickupRequestStatus',
  'createCollectionFromPickupRequest',
])

export const onlineInvoiceMethods = mapActions('onlineInvoices', [
  'getInvoices',
])

export const runsheetMethods = mapActions('runsheets', [
  'getPolyline',
  'runsheetById',
  'runsheetByVehicleId',
  'getRunsheetsByDate',
  'runsheetByNumberPlate',
  'createRunsheet',
  'generateSchedule',
  'getUpcomingRunsheets',
])

export const serviceAgreementMethods = mapActions('serviceAgreements', [
  'serviceAgreementById',
  'serviceAgreementsByClientId',
  'createServiceAgreement',
  'updateServiceAgreement',
  'deleteServiceAgreement',
  'deleteAgreementDocument',
])

export const serviceMethods = mapActions('services', [
  'getServices',
  'getServiceById',
  'getServiceByClientId',
  'createService',
  'updateService',
  'updateServiceSchedule',
  'deleteService',
])

export const serviceTypeMethods = mapActions('serviceTypes', [
  'getServiceTypes',
  'getServiceTypeById',
  'getServiceTypeByName',
  'createServiceType',
  'updateServiceType',
  'deleteServiceType',
  'getAttributes',
])

export const siteMethods = mapActions('sites', [
  'siteById',
  'sitesByClientId',
  'createSite',
  'deleteSite',
  'updateSite',
])

export const tipMethods = mapActions('tips', [
  'getTips',
  'getTipById',
  'createTip',
  'deleteTip',
  'updateTip',
])
export const userMethods = mapActions('users', [
  'getUsers',
  'createUser',
  'userById',
  'updateUser',
  'deleteUser',
])
export const vehicleMethods = mapActions('vehicles', [
  'getVehicles',
  'getVehicleById',
  'getVehicleByNumberPlate',
  'createVehicle',
  'createVehicleCheckList',
  'updateVehicle',
  'deleteVehicle',
  'vehicleRunByVehicleId',
  'createVehicleRun',
  'getVehicleTyreLogs',
  'getVehicleTyreLogsByVehicleId',
  'getMechanicsChecklistByRego',
])

export const vroomScheduleMethods = mapActions('vroomSchedule', [
  'vroomByDate',
  'vroomById',
  'findOrCreateVroomSchedule',
])

export const wastetypeMethods = mapActions('wastetypes', [
  'getWasteTypes',
  'getWasteTypeById',
  'createWasteType',
  'deleteWasteType',
])

export const binPickupMethods = mapActions('binPickups', [
  'createBinPickup',
  'updateBinPickup',
])

export const routeMethods = mapActions('routes', [
  'getRoutes',
  'getRouteById',
  'createRoute',
  'updateRoute',
  'deleteRoute',
])
